'use strict'

import {defineMessages} from 'react-intl'

// messages for the country names on the country dispatch page
export const DISPATCH_COUNTRIES_MESSAGES = defineMessages({
    europe: {
        id: 'region.europe',
        defaultMessage: 'Europe'
    },
    aland_islands: {
        id: 'country.aland_islands',
        defaultMessage: 'Aland Islands'
    },
    albania: {
        id: 'country.albania',
        defaultMessage: 'Albania'
    },
    andorra: {
        id: 'country.andorra',
        defaultMessage: 'Andorra'
    },
    austria: {
        id: 'country.austria',
        defaultMessage: 'Austria'
    },
    belgium: {
        id: 'country.belgium',
        defaultMessage: 'Belgium'
    },
    bosnia_and_herzegovina: {
        id: 'country.bosnia_and_herzegovina',
        defaultMessage: 'Bosnia and Herzegovina'
    },
    bulgaria: {
        id: 'country.bulgaria',
        defaultMessage: 'Bulgaria'
    },
    canary_islands: {
        id: 'country.canary_islands',
        defaultMessage: 'Canary Islands'
    },
    croatia: {
        id: 'country.croatia',
        defaultMessage: 'Croatia'
    },
    cyprus: {
        id: 'country.cyprus',
        defaultMessage: 'Cyprus'
    },
    czech_republic: {
        id: 'country.czech_republic',
        defaultMessage: 'Czech Republic'
    },
    denmark: {
        id: 'country.denmark',
        defaultMessage: 'Denmark'
    },
    estonia: {
        id: 'country.estonia',
        defaultMessage: 'Estonia'
    },
    finland: {
        id: 'country.finland',
        defaultMessage: 'Finland'
    },
    france: {
        id: 'country.france',
        defaultMessage: 'France'
    },
    germany: {
        id: 'country.germany',
        defaultMessage: 'Germany'
    },
    gibraltar: {
        id: 'country.gibraltar',
        defaultMessage: 'Gibraltar'
    },
    greece: {
        id: 'country.greece',
        defaultMessage: 'Greece'
    },
    guernsey: {
        id: 'country.guernsey',
        defaultMessage: 'Guernsey'
    },
    hungary: {
        id: 'country.hungary',
        defaultMessage: 'Hungary'
    },
    iceland: {
        id: 'country.iceland',
        defaultMessage: 'Iceland'
    },
    ireland: {
        id: 'country.ireland',
        defaultMessage: 'Ireland'
    },
    isle_of_man: {
        id: 'country.isle_of_man',
        defaultMessage: 'Isle of Man'
    },
    italy: {
        id: 'country.italy',
        defaultMessage: 'Italy'
    },
    jersey: {
        id: 'country.jersey',
        defaultMessage: 'Jersey'
    },
    latvia: {
        id: 'country.latvia',
        defaultMessage: 'Latvia'
    },
    liechtenstein: {
        id: 'country.liechtenstein',
        defaultMessage: 'Liechtenstein'
    },
    lithuania: {
        id: 'country.lithuania',
        defaultMessage: 'Lithuania'
    },
    luxembourg: {
        id: 'country.luxembourg',
        defaultMessage: 'Luxembourg'
    },
    malta: {
        id: 'country.malta',
        defaultMessage: 'Malta'
    },
    monaco: {
        id: 'country.monaco',
        defaultMessage: 'Monaco'
    },
    montenegro: {
        id: 'country.montenegro',
        defaultMessage: 'Montenegro'
    },
    netherlands: {
        id: 'country.netherlands',
        defaultMessage: 'Netherlands'
    },
    norway: {
        id: 'country.norway',
        defaultMessage: 'Norway'
    },
    poland: {
        id: 'country.poland',
        defaultMessage: 'Poland'
    },
    portugal: {
        id: 'country.portugal',
        defaultMessage: 'Portugal'
    },
    romania: {
        id: 'country.romania',
        defaultMessage: 'Romania'
    },
    russia: {
        id: 'country.russia',
        defaultMessage: 'Russia'
    },
    san_marino: {
        id: 'country.san_marino',
        defaultMessage: 'San Marino'
    },
    serbia: {
        id: 'country.serbia',
        defaultMessage: 'Serbia'
    },
    slovakia: {
        id: 'country.slovakia',
        defaultMessage: 'Slovakia'
    },
    slovenia: {
        id: 'country.slovenia',
        defaultMessage: 'Slovenia'
    },
    spain: {
        id: 'country.spain',
        defaultMessage: 'Spain'
    },
    sweden: {
        id: 'country.sweden',
        defaultMessage: 'Sweden'
    },
    switzerland: {
        id: 'country.switzerland',
        defaultMessage: 'Switzerland'
    },
    united_kingdom: {
        id: 'country.united_kingdom',
        defaultMessage: 'United Kingdom'
    },
    vatican: {
        id: 'country.vatican_city',
        defaultMessage: 'Vatican'
    },
    americas: {
        id: 'region.americas',
        defaultMessage: 'Americas'
    },
    anguilla: {
        id: 'country.anguilla',
        defaultMessage: 'Anguilla'
    },
    antigua_and_barbuda: {
        id: 'country.antigua_and_barbuda',
        defaultMessage: 'Antigua and Barbuda'
    },
    argentina: {
        id: 'country.argentina',
        defaultMessage: 'Argentina'
    },
    aruba: {
        id: 'country.aruba',
        defaultMessage: 'Aruba'
    },
    bahamas: {
        id: 'country.bahamas',
        defaultMessage: 'Bahamas'
    },
    barbados: {
        id: 'country.barbados',
        defaultMessage: 'Barbados'
    },
    belize: {
        id: 'country.belize',
        defaultMessage: 'Belize'
    },
    bermuda: {
        id: 'country.bermuda',
        defaultMessage: 'Bermuda'
    },
    bolivia: {
        id: 'country.bolivia',
        defaultMessage: 'Bolivia'
    },
    brazil: {
        id: 'country.brazil',
        defaultMessage: 'Brazil'
    },
    british_virgin_islands: {
        id: 'country.british_virgin_islands',
        defaultMessage: 'British Virgin Islands'
    },
    canada: {
        id: 'country.canada',
        defaultMessage: 'Canada'
    },
    cayman_islands: {
        id: 'country.cayman_islands',
        defaultMessage: 'Cayman Islands'
    },
    chile: {
        id: 'country.chile',
        defaultMessage: 'Chile'
    },
    colombia: {
        id: 'country.colombia',
        defaultMessage: 'Colombia'
    },
    costa_rica: {
        id: 'country.costa_rica',
        defaultMessage: 'Costa Rica'
    },
    curacao: {
        id: 'country.curacao',
        defaultMessage: 'Curacao'
    },
    dominica: {
        id: 'country.dominica',
        defaultMessage: 'Dominica'
    },
    dominican_republic: {
        id: 'country.dominican_republic',
        defaultMessage: 'Dominican Republic'
    },
    ecuador: {
        id: 'country.ecuador',
        defaultMessage: 'Ecuador'
    },
    el_salvador: {
        id: 'country.el_salvador',
        defaultMessage: 'El Salvador'
    },
    french_guiana: {
        id: 'country.french_guiana',
        defaultMessage: 'French Guiana'
    },
    grenada: {
        id: 'country.grenada',
        defaultMessage: 'Grenada'
    },
    guadeloupe: {
        id: 'country.guadeloupe',
        defaultMessage: 'Guadeloupe'
    },
    guatemala: {
        id: 'country.guatemala',
        defaultMessage: 'Guatemala'
    },
    guyana: {
        id: 'country.guyana',
        defaultMessage: 'Guyana'
    },
    haiti: {
        id: 'country.haiti',
        defaultMessage: 'Haiti'
    },
    honduras: {
        id: 'country.honduras',
        defaultMessage: 'Honduras'
    },
    jamaica: {
        id: 'country.jamaica',
        defaultMessage: 'Jamaica'
    },
    martinique: {
        id: 'country.martinique',
        defaultMessage: 'Martinique'
    },
    mexico: {
        id: 'country.mexico',
        defaultMessage: 'Mexico'
    },
    montserrat: {
        id: 'country.montserrat',
        defaultMessage: 'Montserrat'
    },
    nicaragua: {
        id: 'country.nicaragua',
        defaultMessage: 'Nicaragua'
    },
    panama: {
        id: 'country.panama',
        defaultMessage: 'Panama'
    },
    paraguay: {
        id: 'country.paraguay',
        defaultMessage: 'Paraguay'
    },
    peru: {
        id: 'country.peru',
        defaultMessage: 'Peru'
    },
    saint_barthelemy: {
        id: 'country.saint_barthelemy',
        defaultMessage: 'Saint Barthelemy'
    },
    saint_lucia: {
        id: 'country.saint_lucia',
        defaultMessage: 'Saint Lucia'
    },
    saint_martin: {
        id: 'country.saint_martin',
        defaultMessage: 'Saint Martin'
    },
    saint_vincent_and_the_grenadines: {
        id: 'country.saint_vincent_and_the_grenadines',
        defaultMessage: 'Saint Vincent and the Grenadines'
    },
    trinidad_and_tobago: {
        id: 'country.trinidad_and_tobago',
        defaultMessage: 'Trinidad and Tobago'
    },
    turks_and_caicos_islands: {
        id: 'country.turks_and_caicos_islands',
        defaultMessage: 'Turks and Caicos Islands'
    },
    united_states: {
        id: 'country.united_states',
        defaultMessage: 'United States'
    },
    uruguay: {
        id: 'country.uruguay',
        defaultMessage: 'Uruguay'
    },
    afrique: {
        id: 'region.afrique',
        defaultMessage: 'Afrique'
    },
    angola: {
        id: 'country.angola',
        defaultMessage: 'Angola'
    },
    benin: {
        id: 'country.benin',
        defaultMessage: 'Benin'
    },
    botswana: {
        id: 'country.botswana',
        defaultMessage: 'Botswana'
    },
    burkina_faso: {
        id: 'country.burkina_faso',
        defaultMessage: 'Burkina Faso'
    },
    burundi: {
        id: 'country.burundi',
        defaultMessage: 'Burundi'
    },
    cameroon: {
        id: 'country.cameroon',
        defaultMessage: 'Cameroon'
    },
    chad: {
        id: 'country.chad',
        defaultMessage: 'Chad'
    },
    egypt: {
        id: 'country.egypt',
        defaultMessage: 'Egypt'
    },
    equatorial_guinea: {
        id: 'country.equatorial_guinea',
        defaultMessage: 'Equatorial Guinea'
    },
    eritrea: {
        id: 'country.eritrea',
        defaultMessage: 'Eritrea'
    },
    ethiopia: {
        id: 'country.ethiopia',
        defaultMessage: 'Ethiopia'
    },
    gabon: {
        id: 'country.gabon',
        defaultMessage: 'Gabon'
    },
    gambia: {
        id: 'country.gambia',
        defaultMessage: 'Gambia'
    },
    ghana: {
        id: 'country.ghana',
        defaultMessage: 'Ghana'
    },
    kenya: {
        id: 'country.kenya',
        defaultMessage: 'Kenya'
    },
    lesotho: {
        id: 'country.lesotho',
        defaultMessage: 'Lesotho'
    },
    liberia: {
        id: 'country.liberia',
        defaultMessage: 'Liberia'
    },
    madagascar: {
        id: 'country.madagascar',
        defaultMessage: 'Madagascar'
    },
    malawi: {
        id: 'country.malawi',
        defaultMessage: 'Malawi'
    },
    mali: {
        id: 'country.mali',
        defaultMessage: 'Mali'
    },
    mauritius: {
        id: 'country.mauritius',
        defaultMessage: 'Mauritius'
    },
    mayotte: {
        id: 'country.mayotte',
        defaultMessage: 'Mayotte'
    },
    morocco: {
        id: 'country.morocco',
        defaultMessage: 'Morocco'
    },
    mozambique: {
        id: 'country.mozambique',
        defaultMessage: 'Mozambique'
    },
    namibia: {
        id: 'country.namibia',
        defaultMessage: 'Namibia'
    },
    niger: {
        id: 'country.niger',
        defaultMessage: 'Niger'
    },
    nigeria: {
        id: 'country.nigeria',
        defaultMessage: 'Nigeria'
    },
    republic_of_the_congo: {
        id: 'country.republic_of_the_congo',
        defaultMessage: 'Republic of the Congo'
    },
    reunion: {
        id: 'country.reunion',
        defaultMessage: 'Reunion'
    },
    rwanda: {
        id: 'country.rwanda',
        defaultMessage: 'Rwanda'
    },
    senegal: {
        id: 'country.senegal',
        defaultMessage: 'Senegal'
    },
    sierra_leone: {
        id: 'country.sierra_leone',
        defaultMessage: 'Sierra Leone'
    },
    south_africa: {
        id: 'country.south_africa',
        defaultMessage: 'South Africa'
    },
    swaziland: {
        id: 'country.swaziland',
        defaultMessage: 'Swaziland'
    },
    tanzania: {
        id: 'country.tanzania',
        defaultMessage: 'Tanzania'
    },
    togo: {
        id: 'country.togo',
        defaultMessage: 'Togo'
    },
    uganda: {
        id: 'country.uganda',
        defaultMessage: 'Uganda'
    },
    zambia: {
        id: 'country.zambia',
        defaultMessage: 'Zambia'
    },
    zimbabwe: {
        id: 'country.zimbabwe',
        defaultMessage: 'Zimbabwe'
    },
    asia: {
        id: 'region.asia',
        defaultMessage: 'Asia'
    },
    bahrain: {
        id: 'country.bahrain',
        defaultMessage: 'Bahrain'
    },
    bangladesh: {
        id: 'country.bangladesh',
        defaultMessage: 'Bangladesh'
    },
    bhutan: {
        id: 'country.bhutan',
        defaultMessage: 'Bhutan'
    },
    brunei_darussalam: {
        id: 'country.brunei_darussalam',
        defaultMessage: 'Brunei Darussalam'
    },
    cambodia: {
        id: 'country.cambodia',
        defaultMessage: 'Cambodia'
    },
    china: {
        id: 'country.china',
        defaultMessage: 'China'
    },
    east_timor: {
        id: 'country.east_timor',
        defaultMessage: 'East Timor'
    },
    hong_kong: {
        id: 'country.hong_kong',
        defaultMessage: 'Hong Kong'
    },
    india: {
        id: 'country.india',
        defaultMessage: 'India'
    },
    indonesia: {
        id: 'country.indonesia',
        defaultMessage: 'Indonesia'
    },
    japan: {
        id: 'country.japan',
        defaultMessage: 'Japan'
    },
    kuwait: {
        id: 'country.kuwait',
        defaultMessage: 'Kuwait'
    },
    laos: {
        id: 'country.laos',
        defaultMessage: 'Laos'
    },
    macau: {
        id: 'country.macau',
        defaultMessage: 'Macau'
    },
    malaysia: {
        id: 'country.malaysia',
        defaultMessage: 'Malaysia'
    },
    maldives: {
        id: 'country.maldives',
        defaultMessage: 'Maldives'
    },
    mongolia: {
        id: 'country.mongolia',
        defaultMessage: 'Mongolia'
    },
    oman: {
        id: 'country.oman',
        defaultMessage: 'Oman'
    },
    pakistan: {
        id: 'country.pakistan',
        defaultMessage: 'Pakistan'
    },
    philippines: {
        id: 'country.philippines',
        defaultMessage: 'Philippines'
    },
    qatar: {
        id: 'country.qatar',
        defaultMessage: 'Qatar'
    },
    saudi_arabia: {
        id: 'country.saudi_arabia',
        defaultMessage: 'Saudi Arabia'
    },
    singapore: {
        id: 'country.singapore',
        defaultMessage: 'Singapore'
    },
    south_korea: {
        id: 'country.south_korea',
        defaultMessage: 'South Korea'
    },
    sri_lanka: {
        id: 'country.sri_lanka',
        defaultMessage: 'Sri Lanka'
    },
    taiwan: {
        id: 'country.taiwan',
        defaultMessage: 'Taiwan'
    },
    thailand: {
        id: 'country.thailand',
        defaultMessage: 'Thailand'
    },
    united_arab_emirates: {
        id: 'country.united_arab_emirates',
        defaultMessage: 'United Arab Emirates'
    },
    vietnam: {
        id: 'country.vietnam',
        defaultMessage: 'Vietnam'
    },
    middle_east: {
        id: 'region.middle_east',
        defaultMessage: 'Middle East'
    },
    israel: {
        id: 'country.israel',
        defaultMessage: 'Israel'
    },
    jordan: {
        id: 'country.jordan',
        defaultMessage: 'Jordan'
    },
    turkey: {
        id: 'country.turkey',
        defaultMessage: 'Turkey'
    },
    oceania: {
        id: 'region.oceania',
        defaultMessage: 'Oceania'
    },
    australia: {
        id: 'country.australia',
        defaultMessage: 'Australia'
    },
    fiji: {
        id: 'country.fiji',
        defaultMessage: 'Fiji'
    },
    french_polynesia: {
        id: 'country.french_polynesia',
        defaultMessage: 'French Polynesia'
    },
    new_zealand: {
        id: 'country.new_zealand',
        defaultMessage: 'New Zealand'
    },
    papua_new_guinea: {
        id: 'country.papua_new_guinea',
        defaultMessage: 'Papua New Guinea'
    },
    tokelau: {
        id: 'country.tokelau',
        defaultMessage: 'Tokelau'
    },
    vanuatu: {
        id: 'country.vanuatu',
        defaultMessage: 'Vanuatu'
    },
    wallis_and_futuna: {
        id: 'country.wallis_and_futuna',
        defaultMessage: 'Wallis and Futuna'
    }
})
